export const ARTICLE_LOAD_NUMBER = 10
export const IMG_EXTENSIONS = ['png', 'jpg', 'gif', 'eps']
